import WasmController from "react-lib/frameworks/WasmController";
import * as ARInvoiceGroup from "./sequence/ARInvoiceGroup";
import * as ExportEClaimFile from "./sequence/ExportEClaimFile";
import * as DownloadSentClaimFile from "./sequence/DownloadSentClaimFile";
import * as ImportLabValuesCalcDF from "./sequence/ImportLabValuesCalcDF";
import * as DoctorFeeSummary from "./sequence/DoctorFeeSummary";
import * as DoctorFeeReport from "./sequence/DoctorFeeReport";
import * as UploadPatientCoverage from "./sequence/UploadPatientCoverage";
import * as ClaimTaxDocument from "./sequence/ClaimTaxDocument";
import * as AIPNSendClaim from "./sequence/AIPNSendClaim";
import * as SendClaimResponseFile from "./sequence/SendClaimResponseFile";
import * as CostCenterReceipt from "./sequence/CostCenterReceipt";
import * as SapAccountingReport from "./sequence/SapAccountingReport";
import * as SendClaimDownloadZipFile from "./sequence/SendClaimDownloadZipFile";
import * as BillingPYInterface from "./sequence/BillingPYInterface";
import * as TriggerDischargeInterface from "./sequence/TriggerDischargeInterface";
import * as DrugTransferInterface from "./sequence/DrugTransferInterface";
import * as DrugDispensingInterface from "./sequence/DrugDispensingInterface";
import * as OperatingOrderInterface from "./sequence/OperatingOrderInterface";
import * as DoctorFeeOrderInterface from "./sequence/DoctorFeeOrderInterface";
import * as TriggerInvoiceitem from "./sequence/TriggerInvoiceitem";
import * as LabOrderInterface from "./sequence/LabOrderInterface";
import * as ImagingOrderInterface from "./sequence/ImagingOrderInterface";
import * as TreatmentOrderInterface from "./sequence/TreatmentOrderInterface";
import * as BillingBLInterface from "./sequence/BillingBLInterface";
import * as PatientRecordInterface from "./sequence/PatientRecordInterface";
import * as DFInterface from "./sequence/DFInterface";
import * as EditDivisionSupplyOrder from "./sequence/EditDivisionSupplyOrder";
import * as GenerateOutboundFreezeTime from "./sequence/GenerateOutboundFreezeTime";
import * as GenerateContinueByDate from "./sequence/GenerateContinueByDate";
import * as GenerateContinueByPlan from "./sequence/GenerateContinueByPlan";
import * as AddNedDrugOrderItem from "./sequence/AddNedDrugOrderItem";
import * as PdfMakeHeaderPreview from "./sequence/PdfMakeHeaderPreview";

// APIS
// INF
import ARTransactionList from "issara-sdk/apis/ARTransactionList_apps_INF";
// Core
import EncounterList from "issara-sdk/apis/EncounterList_core";
// CLM
import ImportEmployeePatientCoverageList from "issara-sdk/apis/ImportEmployeePatientCoverageList_apps_CLMM"

export type Props = {

}

export type State = {
  patientCoverageImportData?: {
    columns: string[];
    items_failed: any[];
    items_success: any[];
    total_failed: number;
    total_success: number;
  }
}
  & ARInvoiceGroup.State
  & ExportEClaimFile.State
  & DownloadSentClaimFile.State
  & ImportLabValuesCalcDF.State
  & DoctorFeeSummary.State
  & DoctorFeeReport.State
  & ClaimTaxDocument.State
  & AIPNSendClaim.State
  & UploadPatientCoverage.State
  & SendClaimResponseFile.State
  & ClaimTaxDocument.State
  & CostCenterReceipt.State
  & SapAccountingReport.State
  & SendClaimDownloadZipFile.State
  & BillingPYInterface.State
  & TriggerDischargeInterface.State
  & DrugTransferInterface.State
  & DrugDispensingInterface.State
  & OperatingOrderInterface.State
  & DoctorFeeOrderInterface.State
  & TriggerInvoiceitem.State
  & LabOrderInterface.State
  & ImagingOrderInterface.State
  & TreatmentOrderInterface.State
  & BillingBLInterface.State
  & PatientRecordInterface.State
  & DFInterface.State
  & PdfMakeHeaderPreview.State
  & EditDivisionSupplyOrder.State
  & GenerateOutboundFreezeTime.State
  & GenerateContinueByDate.State
  & GenerateContinueByPlan.State
  & AddNedDrugOrderItem.State

export const StateInitial: State = {
  // ...ARInvoiceGroup.StateInitial,
  // ...ExportEClaimFile.StateInitial,
  // ...DownloadSentClaimFile.StateInitial
};

export type Event =
  | { message: "RunSequence"; params: {} }
  | { message: "GetARTransactions"; params: {} }
  | { message: "GetEncounterList"; params: { type: string } }
  | { message: "HandleUploadPatientCoverage"; params: { type: string } }
  | ARInvoiceGroup.Event
  | ExportEClaimFile.Event
  | DownloadSentClaimFile.Event
  | ImportLabValuesCalcDF.Event
  | DoctorFeeSummary.Event
  | DoctorFeeReport.Event
  | ClaimTaxDocument.Event
  | AIPNSendClaim.Event
  | UploadPatientCoverage.Event
  | SendClaimResponseFile.Event
  | ClaimTaxDocument.Event
  | CostCenterReceipt.Event
  | SapAccountingReport.Event
  | SendClaimDownloadZipFile.Event
  | BillingPYInterface.Event
  | TriggerDischargeInterface.Event
  | DrugTransferInterface.Event
  | DrugDispensingInterface.Event
  | OperatingOrderInterface.Event
  | DoctorFeeOrderInterface.Event
  | TriggerInvoiceitem.Event
  | LabOrderInterface.Event
  | ImagingOrderInterface.Event
  | TreatmentOrderInterface.Event
  | BillingBLInterface.Event
  | PatientRecordInterface.Event
  | DFInterface.Event
  | PdfMakeHeaderPreview.Event
  | EditDivisionSupplyOrder.Event
  | GenerateOutboundFreezeTime.Event
  | GenerateContinueByDate.Event
  | GenerateContinueByPlan.Event
  | AddNedDrugOrderItem.Event

export type Data = {
  division?: number;
  device?: number;
} & ARInvoiceGroup.Data
  & ExportEClaimFile.Data
  & DownloadSentClaimFile.Data
  & ImportLabValuesCalcDF.Data
  & DoctorFeeSummary.Data
  & DoctorFeeReport.Data
  & ClaimTaxDocument.Data
  & AIPNSendClaim.Data
  & UploadPatientCoverage.Data
  & SendClaimResponseFile.Data
  & ClaimTaxDocument.Data
  & CostCenterReceipt.Data
  & SapAccountingReport.Data
  & SendClaimDownloadZipFile.Data
  & BillingPYInterface.Data
  & TriggerDischargeInterface.Data
  & DrugTransferInterface.Data
  & DrugDispensingInterface.Data
  & OperatingOrderInterface.Data
  & DoctorFeeOrderInterface.Data
  & TriggerInvoiceitem.Data
  & LabOrderInterface.Data
  & ImagingOrderInterface.Data
  & TreatmentOrderInterface.Data
  & BillingBLInterface.Data
  & PatientRecordInterface.Data
  & DFInterface.Data
  & PdfMakeHeaderPreview.Data
  & EditDivisionSupplyOrder.Data
  & GenerateOutboundFreezeTime.Data
  & GenerateContinueByDate.Data
  & GenerateContinueByPlan.Data
  & AddNedDrugOrderItem.Data

export const DataInitial = {
  ...ARInvoiceGroup.DataInitial,
  ...ExportEClaimFile.DataInitial,
  ...DownloadSentClaimFile.DataInitial,
  ...ImportLabValuesCalcDF.DataInitial,
  ...DoctorFeeSummary.DataInitial,
  ...DoctorFeeReport.DataInitial,
  ...UploadPatientCoverage.DataInitial,
  ...ClaimTaxDocument.DataInitial,
  ...AIPNSendClaim.DataInitial,
  ...SendClaimResponseFile.DataInitial,
  ...CostCenterReceipt.DataInitial,
  ...SapAccountingReport.DataInitial,
  ...SendClaimDownloadZipFile.DataInitial,
  ...TriggerDischargeInterface.DataInitial,
  ...DrugTransferInterface.DataInitial,
  ...DrugDispensingInterface.DataInitial,
  ...OperatingOrderInterface.DataInitial,
  ...DoctorFeeOrderInterface.DataInitial,
  ...LabOrderInterface.DataInitial,
  ...ImagingOrderInterface.DataInitial,
  ...TreatmentOrderInterface.DataInitial,
  ...BillingBLInterface.DataInitial,
  ...DFInterface.DataInitial,
  ...EditDivisionSupplyOrder.DataInitial,
  ...GenerateOutboundFreezeTime.DataInitial,
  ...GenerateContinueByDate.DataInitial,
  ...GenerateContinueByPlan.DataInitial,
  ...AddNedDrugOrderItem.DataInitial,
  ...PdfMakeHeaderPreview.DataInitial,
};

type Handler = (
  controller: WasmController<State, Event, Data, Props>,
  params?: any
) => any;

export const GetARTransactions: Handler = async (controller, params) => {
  const state = controller.getState()

  controller.setState({
    buttonLoadCheck: {...state.buttonLoadCheck,[params.card]:"LOADING"}
  })

  const response = await ARTransactionList.list({
    apiToken: controller.apiToken,
    params,
  });

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [params.card]: null },
  });

  return response;
};

export const GetEncounterList: Handler = async (controller, params) => {
  const [r, e, n] = await EncounterList.list({
    apiToken: controller.apiToken,
    params: {
      ...params,
    },
  });
  if (e) {
    return [[], null];
  }

  return [r.items, e];
};

export const HandleUploadPatientCoverage: Handler = async (controller, params) => {
  const state = controller.getState()

  const buttonKey = `${params.card}_${params.btnAction}`

  controller.setState({
    buttonLoadCheck: { ...state.buttonLoadCheck, [buttonKey]: "LOADING" }
  })
  //* - fiscal_year = xxxx B.E.  ปีงบประมาณ
  //* - max_reimb = 10000  วงเงิน
  //* - save = true/false (เอาไว้ให้เทส upload ให้ส่ง false มา )
  //* - file = file.xlsx ที่เอาไว้ import
  const data = {
    fiscal_year: params.fiscalYear,
    max_reimb: params.maxReimb,
    save: true,
    file: params.file
  }

  const result = await ImportEmployeePatientCoverageList.create({
    apiToken: controller.apiToken,
    data
  });


  if (result[1]) {
    controller.setState({
      errorMessage: { ...state.errorMessage, [params.card]: result[1] },
      buttonLoadCheck: { ...state.buttonLoadCheck, [buttonKey]: "ERROR" }
    })
  } else {
    params.onSuccess?.()

    controller.setState({
      patientCoverageImportData: result[0],
      buttonLoadCheck: { ...state.buttonLoadCheck, [buttonKey]: "SUCCESS" }
    })
  }
}
